import { apiClient } from './apiClient';

const handleCedenteError = (error) => {
    if (error.response?.status === 400) {
        const detail = error.response.data.detail;
        throw new Error(typeof detail === 'string' ? detail : "Dados de acesso inválidos.");
    }
    if (error.response?.status === 404) {
        throw new Error("Usuário não encontrado em nossa base de dados.");
    }
    if (error.response?.status === 403) {
        throw new Error(error.response.data.detail || "Conta inativa. Por favor, entre em contato com o suporte.");
    }
    throw error;
};

export const authService = {
    // CPF lookup for regular cedente users (end users who sign documents)
    login: async (cpf) => {
        try {
            const response = await apiClient.get(`/cedentes/cpf/${encodeURIComponent(cpf)}`);
            return response.data;
        } catch (error) {
            handleCedenteError(error);
        }
    },

    // UUID lookup — used when cedente accesses via ?id=<uuid> link (no PII in URL)
    loginById: async (id) => {
        try {
            const response = await apiClient.get(`/cedentes/by-uuid/${encodeURIComponent(id)}`);
            return response.data;
        } catch (error) {
            handleCedenteError(error);
        }
    },

    // JWT login for system users: ADMIN, SINDICATO, OPERADOR
    adminLogin: async (email, password) => {
        try {
            const response = await apiClient.post('/login', { email, password });
            return response.data;
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                throw new Error("Credenciais inválidas.");
            }
            throw error;
        }
    },
};
